<template>
    <div :class="[ visible ? 'col-lg-9 col-xl-10 col-xs-12 d-block' : 'col-lg-9 col-xl-10 col-xs-12 d-none']">
      <b-card v-if="dataToDisplay.length === 0" class="mb-xlg border-0">
        <a href="#" class="fw-semi-bold text-success">Hurray! </a>
        <hr />
        <div class="mb-lg">
          You have No Carried Over Incompleted Tasks
        </div>
        <b-button class="btn-rounded-f" variant="success">Check your Daily Tasks</b-button>
      </b-card>
    <Pagination v-if="openedTask === null && !compose" />
    <b-button v-else variant="default" class="mb" @click="openTask(null)">
      <i class="fa fa-angle-left fa-lg" />
    </b-button>
    <div v-if="dataToDisplay.length > 0">
      <div v-if="loading" class="loader">Loading...</div>
      <Widget v-if="openedTask === null && !compose">
          <TaskTableHeader
            :title="title"
            :search="search"
            :chooseAll="chooseAll"
            :chooseNone="chooseNone"
            :chooseRead="chooseRead"
            :chooseUnread="chooseUnread"
            :markRead="markRead"
            :markUnread="markUnread"
            :deleteMsg="deleteMsg"
          />
          <div class="table-responsive">
            <table class="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th>
                  </th>
                  <th>
                    <div class="abc-checkbox">
                      <input
                        type="checkbox"
                        id="tasktable-checkbox"
                        @click="isMainChecked ? chooseNone() : chooseAll()"
                        :checked="isMainChecked"
                      />
                      <label for="tasktable-checkbox" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="task in dataToDisplay"
                  v-show="_searchable(task)"
                  :key="task.id"
                  :class="{ unreadedTask: task.unreaded }"
                >
                  <td class="taskContext">
                    <i class="fa fa-ellipsis-v"></i>
                  </td>
                  <td class="taskCheckbox">
                    <div class="abc-checkbox">
                      <input
                        type="checkbox"
                        :id="`checkbox${task.id}`"
                        :checked="checkedIds.indexOf(task.id) !== -1"
                        @change="changeChoosed(task.id)"
                      />
                      <label :for="`checkbox${task.id}`" />
                    </div>
                  </td>
                  <td
                    class="taskStar"
                    @click="starItem(task.id)"
                  >
                      <span v-if="task.starred" class="taskStarred">
                        <i class="fa fa-star" />
                      </span>
                      <span v-else><i class="fa fa-star-o" /></span>
                  </td>
                  
                  <td @click="handleOpenTask(task.id)">{{task.Title}}</td>
                  <td class="taskClip">
                    <i v-show="task.HasAssets" class="fa fa-paperclip" />
                  </td>
                  <td>
                    <i v-show="task.HasComments" class="fa fa-comments-o"></i>
                  </td>
                  <td class="text-right">{{task.DueDate}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Widget>
      <Compose v-else-if="compose" :data="composeData" />
      <Task v-else :changeCompose="changeCompose" :task="this.tasks.find(m => m.id === openedTask)" />
      </div>
  </div>
</template>

<script>
import Vue from 'vue';

import Widget from '@/components/Widget/Widget';
import Pagination from '../Pagination/Pagination';
import TaskTableHeader from '../TaskTableHeader/TaskTableHeader';
import Task from '../Task/Task';
import Compose from '../Compose/Compose';

//import mock from '../../mock';

import { mapState, mapActions } from 'vuex'

export default {
  name: 'TaskTable',
  components: {
    Widget, Pagination, TaskTableHeader, Task, Compose,
  },
  props: ['visible', 'filter', 'openedTask', 'openTask', 'composeData', 'changeCompose', 'compose'],
  data() {
    return {
      //tasks: mock,
      title: 'Carried Over Incomplete Tasks',
      checkedIds: [],
      searchString: '',
    };
  },
  created() {
      this.init();
  },
  methods: {
    ...mapActions('tasks', ['getTasks']),

    init() {
      this.getTasks({ employeeID: "2"});
    },
    
    changeChoosed(id) {
      const index = this.checkedIds.indexOf(id);

      if (index === -1) {
        this.checkedIds.push(id);
      } else {
        this.checkedIds.splice(index, 1);
      }
    },
    chooseAll() {
      this.chooseNone();

      const { tasks, filter, checkedIds } = this;

      if (filter) {
        if (this.filter === 'INCOMPLETE')
          this.tasks.filter(task => task.Status === this.filter).forEach(task => checkedIds.push(task.id));
        else
          this.tasks.filter(task => task.TaskType === this.filter  && task.Status !== 'COMPLETED').forEach(task => checkedIds.push(task.id));
      } else {
        tasks.forEach(task => checkedIds.push(task.id));
      }
    },
    chooseNone() {
      this.checkedIds = [];
    },
    chooseRead() {
      this.chooseNone();

      this.tasks.forEach((task) => {
        if (!task.unreaded) {
          this.checkedIds.push(task.id);
        }
      });
    },
    chooseUnread() {
      this.chooseNone();

      this.tasks.forEach((task) => {
        if (task.unreaded) {
          this.checkedIds.push(task.id);
        }
      });
    },
    markUnread() {
      this.tasks.map((task) => {
        if (this.checkedIds.indexOf(task.id) !== -1) {
          task.unreaded = true; // eslint-disable-line
        }

        return task;
      });
    },
    markRead() {
      this.tasks.map((task) => {
        if (this.checkedIds.indexOf(task.id) !== -1) {
          task.unreaded = false; // eslint-disable-line
        }

        return task;
      });
    },
    deleteMsg() {
      this.tasks = this.tasks.filter(m => this.checkedIds.indexOf(m.id) === -1);
      this.chooseNone();
    },
    starItem(id) {
      const task = this.tasks.find(m => m.id === id);

      task.starred = !task.starred;
    },
    handleOpenTask(id) {
      this.tasks.find(m => m.id === id).unreaded = false;

      this.openTask(id);
    },
    search(value) {
      Vue.set(this, 'searchString', value.toLowerCase());
    },
    _searchable(m) {
      if (this.searchString) {
        return (m.content.toLowerCase().indexOf(this.searchString) !== -1
          || m.from.toLowerCase().indexOf(this.searchString) !== -1
          || m.theme.toLowerCase().indexOf(this.searchString) !== -1);
      }

      return true;
    },
  },
  computed: {
    ...mapState({
        loading: state => state.tasks.loading,
        tasks: state => state.tasks.tasks,
        assets: state => state.tasks.assets,
    }),
    filteredTasks() {
      if (this.filter === 'INCOMPLETE')
        return this.tasks.filter(task => task.Status == this.filter);
      else
        return this.tasks.filter(task => task.TaskType == this.filter  && task.Status != 'COMPLETED');
    },
    dataToDisplay() {
      return this.filter ? this.filteredTasks : this.tasks;
    },
    isMainChecked() {
      return this.dataToDisplay.length === this.checkedIds.length;
    }
  },
  watch: {
    filter(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.chooseNone();
      }
    },
  },
};
</script>

<style src="./TaskTable.scss" lang="scss" scoped />
